import InlineReplacement from './base/inline-replacement';
import LinkReplacer from '@intercom/embercom-composer/lib/link-replacer';
export default InlineReplacement.extend().reopenClass({
  delimiter: /(^|\s)[^\s].$/,
  tryReplacementWithIndex(block, index, options) {
    if (block.get('config.urlReplacement')) {
      let replacer = new LinkReplacer(block);
      replacer.replaceLinksAtIndex(index, this.delimiter, options);
    }
  },
  tryReplacement(block, mutationResult) {
    if (block.get('config.urlReplacement')) {
      let replacer = new LinkReplacer(block);
      replacer.replaceLinks({
        mutationResult
      });
    }
  }
});